import { exportErrorFragment } from "@saleor/fragments/errors";
import { exportFileFragment } from "@saleor/fragments/products";
import makeMutation from "@saleor/hooks/makeMutation";
import {
  OrderExport,
  OrderExportVariables
} from "@saleor/motherOrders/types/OrderExport";
import gql from "graphql-tag";

export const useExportOrdersMutation = gql`
  ${exportFileFragment}
  ${exportErrorFragment}
  mutation OrderExport($input: ExportOrdersInput!) {
    exportOrders(input: $input) {
      exportFile {
        ...ExportFileFragment
        __typename
      }
      errors: exportErrors {
        ...ExportErrorFragment
        __typename
      }
      __typename
    }
  }
`;

export const useExportOrders = makeMutation<OrderExport, OrderExportVariables>(
  useExportOrdersMutation
);
